module.exports = __webpack_public_path__ + "front/img/kv02.f150262b.png";